import CreateClassroomManagementView from "@features/tools/view/classroom-management/create-classroom-management-view";

const CreateClassroomManagement = () => {
  return <CreateClassroomManagementView />;
};

export default CreateClassroomManagement;
